export default {
  
  methods: {

    draw_Pie(angle, fa, len, sRa, d) {

      let pie = this.pie
      let aRad = (angle - d.gap) * Math.PI / 180

      let pieArea = this.radialCanvas
      .append('g')
      .attr('id', `${d.id}_${d.data.SYS_CODE}`)
      .attr('transform', `translate(0,0) rotate(${(pie.spin + fa)})`)
      .style('cursor', 'pointer').attr('opacity', 1)
      .on('mouseover', ()=> {
        this.call_Pie_Over(d.data)
      })
      .on('mouseout', ()=> {
        this.call_Pie_Out(d.data)
      })
      .on('click', ()=> {
        this.exec_Handover(d.data.SYS_CODE)
      })

      pieArea
      .append('path')
      .attr('d', `
        M ${pie.ra * sRa} 0 
        L ${len} 0 
        A ${len} ${len} 0 0 1 ${len * Math.cos(aRad)} ${len * Math.sin(aRad)}
        L ${pie.ra * sRa * Math.cos(aRad)} ${pie.ra * sRa * Math.sin(aRad)}
        A ${pie.ra * sRa} ${pie.ra * sRa} 0 0 0 ${pie.ra * sRa} 0
      `)
      .attr('fill', d.bColor).attr('fill-opacity', d.opacity[0])
      .attr('stroke', d.sColor).attr('stroke-width', d.sWidth).attr('stroke-opacity', d.opacity[1])
      .attr('filter', d.id == 'ACTUAL' ? 'url(#dropshadow)' : '')

      pieArea
      .append('text')
      .attr('transform', `translate(${0}, ${0}) rotate(${angle/2})`)
      .attr('x', this.pie.ra + 5)
      .attr('font-size', 11).attr('fill', '#000')
      .text(d.data.DESC)
    },
    

    draw_Grids(sRa) {
      let ra = this.pie.ra
      let length = ra - (ra * sRa)

      let grids = this.radialCanvas
      .append('g')
      .attr('transform', `translate(0, ${-ra})`)
      .attr('opacity', .7)

      grids
      .append('line')
      .attr('x1', 0).attr('y1', 0).attr('x2', 0).attr('y2', length)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 1)

      for(let i=0; i<=5; i++) {
        grids
        .append('line')
        .attr('x1', -3).attr('y1', (length/5)*i).attr('x2', 3).attr('y2', (length/5)*i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', 1)

        grids
        .append('text')
        .attr('x', 4).attr('y', (length/5)*i +2.5).attr('font-size', 8).attr('fill', '#000')
        .text(`${100 - (i*20)}%`)
      }
    },
  }
}